import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#101828",
  },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },

  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  logo:{
 width:"120px",
 height:"auto",
 alignSelf:"center"
  },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportWorkersPDF = ({ data,logo }) => {
  const { t } = useTranslation();


  return (
    <Document>
      <Page size="A4" style={styles.page}>

           {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        
        <Text style={styles.heading}>{t("workers.manageWorkers")}</Text>
         
        {data.map((item, idx) => (
          <View key={idx} style={styles.recordGroup}>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.id")}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.workerName")}:</Text>
              <Text style={styles.value}>{item.name}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.email")}:</Text>
              <Text style={styles.value}>{item.email}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.phoneNo")}:</Text>
              <Text style={styles.value}>{item.phone}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.department")}:</Text>
              <Text style={styles.value}>{item.department}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.type")}:</Text>
              <Text style={styles.value}>{item.type}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.shift")}:</Text>
              <Text style={styles.value}>{item.shift}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.status")}:</Text>
              <Text style={styles.value}>{item.status}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.registered")}:</Text>
              <Text style={styles.value}>{item.date}</Text>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  );
};

export default ExportWorkersPDF;